@if (showStartupLoader()) {
  <div class="lp-loader" id="loader">
    <img src="/logo/pc_loader.svg" alt="Loading..." class="lp-loader-image" />
  </div>
} @else {
  <div class="lp">
    <!-- LANDING PAGE NAVBAR -->

    <header class="lp-nav" aria-label="Primary navigation">
      <div class="lp-container lp-nav__inner">
        <a class="lp-nav__brand" href="/" aria-label="PrivateCircle Chat home">
          <img src="/logo/logo_light.svg" alt="PrivateCircle Chat" />
        </a>

        <button
          class="lp-nav__login lp-animated-border"
          type="button"
          (click)="login()"
          [disabled]="isExchanging()"
        >
          Login
        </button>
      </div>
    </header>

    <main class="lp-main">
      <!-- LP HERO SECTION-->

      <section class="lp-hero" aria-label="Hero">
        <img class="lp-hero__bg" ngSrc="/landing/hero/hero-bg.webp" alt="" fill priority />

        <div class="lp-container lp-hero__inner">
          <h1 class="lp-hero__title">Your AI Analyst <br />For Private Markets</h1>
          <p class="lp-hero__subtitle">Stop searching. Start asking</p>

          <div class="lp-hero__actions" aria-label="Get started">
            <button
              class="lp-btn lp-btn--primary lp-animated-border"
              type="button"
              (click)="register()"
              [disabled]="isExchanging()"
            >
              <span>AskPC Now</span>
              <ui-icon name="ph-arrow-right" [size]="16" />
            </button>
            <div class="lp-hero__note">3 million tokens free. No credit card required.</div>
          </div>

          @if (isExchanging()) {
            <div class="lp-status" role="status" aria-live="polite">Signing you in…</div>
          }

          <div #elevateOnScroll class="lp-hero__mock elevate-on-scroll">
            <video
              #heroVideo
              class="lp-hero__mockVideo"
              autoplay
              muted
              loop
              playsinline
              preload="metadata"
              width="900"
              height="544"
              aria-label="Chat interface preview"
            >
              @if (!isBelow720()) {
                <source src="/landing/hero/landing-hero.mp4" type="video/mp4" />
              } @else {
                <source src="/landing/hero/landing-hero-video-phone.mp4" type="video/mp4" />
              }
            </video>
          </div>
        </div>
      </section>

      <!-- CUSTOMER LOGOS-->

      <section class="lp-marquee" aria-label="Customer logos">
        <div class="lp-container lp-marquee__inner">
          <p class="lp-marquee__title">
            Join 1000+ financial leaders choosing PrivateCircle Research for verified private market
            data.
          </p>
        </div>

        <div #marqueeRail class="lp-marquee__rail" aria-hidden="true" (click)="onMarqueeTap()">
          <div class="lp-marquee__track" [class.is-paused]="isMarqueePaused()">
            @for (logo of marqueeLogos; track logo.src) {
              <img
                class="lp-marquee__logo"
                [src]="logo.src"
                alt=""
                width="80"
                height="80"
                loading="lazy"
              />
            }
            @for (logo of marqueeLogos; track logo.src + '-dup') {
              <img
                class="lp-marquee__logo"
                [src]="logo.src"
                alt=""
                width="80"
                height="80"
                loading="lazy"
              />
            }
          </div>
        </div>
      </section>

      <!-- CONTEXTUAL SIDEBAR SECTION-->

      <!--    <section class="lp-contextual-sidebar lp-container">-->
      <!--      <div class=" lp-contextual-sidebar__header">-->
      <!--        <div class="lp-contextual-sidebar__titleBlock">-->
      <!--          <div class="lp-contextual-sidebar__titleBlock__title">-->
      <!--            {{ contextualSidebarHeadline.leading }}-->
      <!--            <span class="lp-muted"> {{ contextualSidebarHeadline.muted }}</span>-->
      <!--          </div>-->
      <!--          <div class="lp-contextual-sidebar__titleBlock__sub-title" [innerHTML]="contextualSidebarHeadline.body">-->
      <!--          </div>-->
      <!--          <div class="lp-contextual-sidebar__titleBlock__sub-title-two" [innerHTML]="contextualSidebarHeadline.body2">-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <button class="lp-btn lp-btn&#45;&#45;primary lp-animated-border" type="button" (click)="register()"-->
      <!--                [disabled]="isExchanging()">-->
      <!--          <span>AskPC Now</span>-->
      <!--          <ui-icon name="ph-arrow-right" [size]="16"/>-->
      <!--        </button>-->
      <!--      </div>-->
      <!--      <div class="lp-contextual-sidebar__mock">-->
      <!--        <img-->
      <!--          class="lp-contextual-sidebar__mockImg"-->
      <!--          ngSrc="/landing/contextual-sidebar/contextual-sidebar-screenshot.svg"-->
      <!--          width="870"-->
      <!--          height="544"-->
      <!--          priority-->
      <!--          alt="Chat interface preview"-->
      <!--        />-->
      <!--      </div>-->
      <!--    </section>-->

      <!--WORKFLOWS SECTION-->

      <section class="lp-workflows" aria-label="Workflows">
        <div class="lp-container lp-workflows__header">
          <h2 class="lp-h2 lp-workflows__title">
            The <span class="lp-muted"> Full Spectrum</span> of Private Market Data
          </h2>
        </div>

        <div class="lp-container lp-workflows__grid">
          @for (card of workflowCards; track card.id; let i = $index) {
            <article class="lp-card lp-card--{{ card.variant }} lp-card--{{ $index + 1 }}">
              <div class="lp-card__head">
                <div class="lp-card__title">
                  <div>{{ card.title }}</div>
                </div>
              </div>
              <p class="lp-card__body">{{ card.description }}</p>
            </article>
          }
        </div>
      </section>

      <!-- LP COMPARISON SECTION-->

      <section class="lp-compare" aria-label="Comparison">
        <div class="lp-container lp-compare__inner">
          <h2 class="lp-h2 lp-compare__title">
            {{ comparisonHeadline.leading }}
            <span class="lp-muted"> {{ comparisonHeadline.muted }}</span>
          </h2>

          @if (!isBelow720()) {
            <!-- Row-aligned grid (desktop/tablet) -->
            <div class="lp-compare__table" aria-label="Comparison table">
              <div class="lp-compare__colHead">
                <div class="lp-compare__badge lp-compare__badge--gray" aria-hidden="true">
                  <ui-icon name="head-circuit" [size]="20" />
                </div>
                <div class="lp-compare__colTitle">Generic AI Models</div>
              </div>
              <div class="lp-compare__colHead">
                <div class="lp-compare__badge lp-compare__badge--blue" aria-hidden="true">
                  <ui-icon name="database" [size]="20" />
                </div>
                <div class="lp-compare__colTitle">
                  <img
                    ngSrc="/logo/logo_light.svg"
                    width="98"
                    height="26"
                    alt="PrivateCircle Chat"
                  />
                </div>
              </div>

              @for (row of comparisonRows; track row.id) {
                @if (row.generic) {
                  <div class="lp-compare__item">
                    <span class="lp-compare__dot lp-compare__dot--bad" aria-hidden="true">
                      <ui-icon name="close" [size]="12" />
                    </span>
                    <span>{{ row.generic.text }}</span>
                  </div>
                } @else {
                  <div class="lp-compare__cellEmpty" aria-hidden="true"></div>
                }

                @if (row.askpc) {
                  <div class="lp-compare__item">
                    <span class="lp-compare__dot lp-compare__dot--good" aria-hidden="true">
                      <ui-icon name="check" [size]="12" />
                    </span>
                    <span>{{ row.askpc.text }}</span>
                  </div>
                } @else {
                  <div class="lp-compare__cellEmpty" aria-hidden="true"></div>
                }
              }
            </div>
          } @else {
            <!-- Phone layout: columns stacked one after another -->
            <div class="lp-compare__cols">
              <div class="lp-compare__col">
                <div class="lp-compare__colHead">
                  <div class="lp-compare__badge lp-compare__badge--gray" aria-hidden="true">
                    <ui-icon name="head-circuit" [size]="20" />
                  </div>
                  <div class="lp-compare__colTitle">Generic AI Models</div>
                </div>

                <ul class="lp-compare__list">
                  @for (p of comparisonGeneric; track p.id) {
                    <li class="lp-compare__item">
                      <span class="lp-compare__dot lp-compare__dot--bad" aria-hidden="true">
                        <ui-icon name="close" [size]="12" />
                      </span>
                      <span>{{ p.text }}</span>
                    </li>
                  }
                </ul>
              </div>

              <div class="lp-compare__col">
                <div class="lp-compare__colHead">
                  <div class="lp-compare__badge lp-compare__badge--blue" aria-hidden="true">
                    <ui-icon name="database" [size]="20" />
                  </div>
                  <div class="lp-compare__colTitle">
                    <img
                      ngSrc="/logo/logo_light.svg"
                      width="98"
                      height="26"
                      alt="PrivateCircle Chat"
                    />
                  </div>
                </div>

                <ul class="lp-compare__list">
                  @for (p of comparisonPcChat; track p.id) {
                    <li class="lp-compare__item">
                      <span class="lp-compare__dot lp-compare__dot--good" aria-hidden="true">
                        <ui-icon name="check" [size]="12" />
                      </span>
                      <span>{{ p.text }}</span>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }

          <button
            class="lp-btn lp-btn--primary lp-animated-border"
            type="button"
            (click)="register()"
            [disabled]="isExchanging()"
          >
            <span>AskPC Now</span>
            <ui-icon name="ph-arrow-right" [size]="16" />
          </button>
        </div>
      </section>

      <section class="lp-metrics" aria-label="Metrics">
        <div class="lp-container lp-metrics__grid">
          @for (m of metrics(); track m.id) {
            <div class="lp-metric">
              <div class="lp-metric__value">{{ m.value }}</div>
              <div class="lp-metric__label">{{ m.label }}</div>
            </div>
          }
        </div>
      </section>

      <!-- LP USE CASES SECTION-->

      <!--    <section class="lp-usecases" aria-label="Use cases">-->
      <!--      <div class="lp-usecases__header">-->
      <!--        <h2 class="lp-h2">-->
      <!--          {{ useCases.headingLeading }} for-->
      <!--          <span class="lp-muted">  {{ useCases.headingMuted }}</span>-->
      <!--        </h2>-->
      <!--        <p class="lp-p">{{ useCases.body }}</p>-->
      <!--      </div>-->
      <!--      <div class="lp-container lp-usecases__grid">-->
      <!--        <div class="lp-usecases__left">-->
      <!--          <div class="lp-usecases__list" aria-label="Teams">-->
      <!--            @for (team of useCaseTeams; track team.id) {-->
      <!--              <button-->
      <!--                class="lp-usecases__item "-->
      <!--                [class.is-active]="team.id === activeUseCaseTeamId()"-->
      <!--                [class.lp-animated-border]="team.id === activeUseCaseTeamId()"-->
      <!--                type="button"-->
      <!--                [attr.aria-pressed]="team.id === activeUseCaseTeamId()"-->
      <!--                [attr.aria-label]="'Select team: ' + team.title"-->
      <!--                (click)="toggleTeam(team.id)">-->
      <!--                <div class="lp-usecases__itemText">-->
      <!--                  <div class="lp-usecases__itemTitle">{{ team.title }}</div>-->
      <!--                  <div class="lp-usecases__itemSub">{{ team.subtitle }}</div>-->
      <!--                </div>-->
      <!--                <ui-icon-->
      <!--                  [name]="-->
      <!--    isBelow1250()-->
      <!--      ? (team.id === activeUseCaseTeamId() ? 'ph-caret-up' : 'ph-caret-down')-->
      <!--      : 'ph-caret-right'-->
      <!--  "-->
      <!--                  [size]="20"-->
      <!--                  class="lp-usecases__caret"-->
      <!--                  [class.is-active]="team.id === activeUseCaseTeamId()"-->
      <!--                />-->
      <!--              </button>-->
      <!--              @if (isBelow1250()) {-->

      <!--                <div-->
      <!--                  class="lp-usecases__slot"-->
      <!--                  [class.is-open]="team.id === activeUseCaseTeamId() && isBelow1250()"-->
      <!--                >-->
      <!--                  <div class="lp-usecases__right" aria-label="Chat preview">-->
      <!--                    <img-->
      <!--                      class="lp-usecases__chat"-->
      <!--                      [ngSrc]="activeTeam()?.image ?? ''"-->
      <!--                      width="704"-->
      <!--                      height="611"-->
      <!--                      [alt]="activeTeam()?.title"-->
      <!--                      loading="lazy"-->
      <!--                    />-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              }-->
      <!--            }-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        @if (!isBelow1250()) {-->
      <!--<div class="lp-usecases__right" aria-label="Chat preview">-->
      <!--  @for (team of useCaseTeams; track team.id) {-->
      <!--    <img-->
      <!--      class="lp-usecases__chat"-->
      <!--      [class.is-active]="team.id === activeUseCaseTeamId()"-->
      <!--      [ngSrc]="team.image"-->
      <!--      width="704"-->
      <!--      height="611"-->
      <!--    />-->
      <!--  }-->
      <!--</div>-->

      <!--        }-->

      <!--      </div>-->
      <!--      <div class="lp-usecases__footer">-->
      <!--        <button class="lp-btn lp-btn&#45;&#45;primary lp-animated-border" type="button" (click)="register()"-->
      <!--                [disabled]="isExchanging()">-->
      <!--          <span>AskPC Now</span>-->
      <!--          <ui-icon name="ph-arrow-right" [size]="16"/>-->
      <!--        </button>-->
      <!--      </div>-->

      <!--    </section>-->

      <!-- LP PLANS SECTION-->

      <section class="lp-plans" aria-label="Plans">
        <img class="lp-plans__bg" ngSrc="/landing/hero/hero-bg.webp" alt="" fill />

        <div class="lp-container lp-plans__inner">
          <h2 class="lp-h2 lp-plans__title">Choose Your Plan</h2>
          <p class="lp-p lp-plans__subtitle">
            Start with 3 million free tokens. Scale as you grow with flexible pricing that fits your
            needs.
          </p>

          <div class="lp-plans__grid">
            <app-plan-grid [plans]="plans()" (selected)="onSelected($event)"></app-plan-grid>
          </div>

          <!--        <div class="lp-plans__includes">-->
          <!--          <div class="lp-plans__includesTitle">All plans include:</div>-->
          <!--          <ul class="lp-plans__includesList">-->
          <!--            @for (item of plans.includes; track item) {-->
          <!--              <li class="lp-plans__includesItem">-->
          <!--                <ui-icon name="check" [size]="18"/>-->
          <!--                <span>{{ item }}</span>-->
          <!--              </li>-->
          <!--            }-->
          <!--          </ul>-->
          <!--        </div>-->
        </div>
      </section>

      <!-- LP PLANS SECTION-->

      <section class="lp-faq" aria-label="FAQ">
        <h2 class="lp-faq__title">{{ isBelow720() ? 'FAQ' : 'Frequently Asked Questions' }}</h2>
        <div class="lp-faq__body">
          <app-faq-page [isPreLoginPage]="true"></app-faq-page>
        </div>
      </section>

      <!-- LP FINAL CALL TO ACTION-->

      <section class="lp-final" aria-label="Final call to action">
        <div class="lp-container lp-final__inner">
          <h2 class="lp-final__title">
            Your first <span class="lp-muted">3 million</span> tokens are on us. Start asking
          </h2>
          <p class="lp-final__subtitle">{{ finalCta.body }}</p>
          <button
            class="lp-btn lp-btn--primary lp-btn--onDark lp-animated-border"
            type="button"
            (click)="register()"
            [disabled]="isExchanging()"
          >
            <span>AskPC Now</span>
            <ui-icon name="ph-arrow-right" [size]="16" />
          </button>
        </div>
      </section>

      <!-- LP FOOTER SECTION-->

      <footer class="lp-footer" aria-label="Footer">
        <div class="lp-footer__inner">
          <div class="lp-footer__top">
            <div class="lp-footer__left">
              <img
                class="lp-footer__logo"
                src="/logo/logo_light.svg"
                width="185"
                height="46"
                alt="PrivateCircle"
              />

              <div class="lp-footer__addr">
                @for (line of footerLeft.addressLines; track line) {
                  <div>{{ line }}</div>
                }
              </div>

              <div class="lp-footer__contact">
                @for (item of footerLeft.contactLines; track item.id) {
                  @if (item.type === 'email') {
                    <a
                      class="lp-footer__contactLink"
                      [href]="'mailto:' + (item.value ?? item.label)"
                      >{{ item.label }}</a
                    >
                  } @else if (item.type === 'tel') {
                    <a
                      class="lp-footer__contactLink"
                      [href]="'tel:' + (item.value ?? item.label)"
                      >{{ item.label }}</a
                    >
                  } @else {
                    <div>{{ item.label }}</div>
                  }
                }
              </div>
            </div>

            <div class="lp-footer__right" aria-label="Footer links">
              <!-- Desktop columns -->
              <div class="lp-footer__cols">
                @for (col of footerRightColumns; track col.id) {
                  <div class="lp-footer__col">
                    <div class="lp-footer__colTitle">{{ col.title }}</div>
                    <div class="lp-footer__colLinks">
                      @for (link of col.links; track link.id) {
                        @if (!link.href) {
                          <span class="lp-footer__link is-disabled">{{ link.label }}</span>
                        } @else if (link.external) {
                          <a
                            class="lp-footer__link"
                            [href]="link.href"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ link.label }}</a
                          >
                        } @else {
                          <a class="lp-footer__link" target="_blank" [href]="link.href">{{
                            link.label
                          }}</a>
                        }
                      }
                    </div>
                  </div>
                }
              </div>

              <!-- Tablet/phone accordion -->
              <div class="lp-footerAcc__list" aria-label="Footer sections">
                <div class="lp-footerAcc__rule" aria-hidden="true"></div>

                @for (col of footerRightColumns; track col.id) {
                  <button
                    class="lp-footerAcc__row"
                    type="button"
                    [attr.aria-expanded]="openFooterSectionId() === col.id"
                    (click)="toggleFooterSection(col.id)"
                  >
                    <span>{{ col.title }}</span>
                    <img
                      class="lp-footerAcc__chev"
                      src="/landing/footer/chevron-16.svg"
                      alt=""
                      width="16"
                      height="16"
                      [class.is-open]="openFooterSectionId() === col.id"
                    />
                  </button>

                  @if (openFooterSectionId() === col.id) {
                    <div
                      class="lp-footerAcc__items"
                      role="group"
                      [attr.aria-label]="col.title + ' links'"
                    >
                      @for (link of col.links; track link.id) {
                        @if (link.showInAccordion !== false) {
                          @if (!link.href) {
                            <span class="lp-footerAcc__item is-disabled"
                              ><span>{{ link.label }}</span></span
                            >
                          } @else if (link.external) {
                            <a
                              class="lp-footerAcc__item"
                              [href]="link.href"
                              target="_blank"
                              rel="noopener noreferrer"
                              ><span>{{ link.label }}</span></a
                            >
                          } @else {
                            <a class="lp-footerAcc__item" target="_blank" [href]="link.href"
                              ><span>{{ link.label }}</span></a
                            >
                          }
                        }
                      }
                    </div>
                  }
                  <div class="lp-footerAcc__rule" aria-hidden="true"></div>
                }
              </div>
            </div>
          </div>

          <div class="lp-footer__divider" aria-hidden="true"></div>

          <div class="lp-footer__bottom">
            <div class="lp-footer__copyright">Copyright © {{ currentYear }} PrivateCircle ™</div>
            <div class="lp-footer__social" aria-label="Social links">
              <a
                class="lp-footer__socialBtn"
                [href]="footerSocial.linkedin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <img
                  src="/landing/footer/linkedin-24.svg"
                  alt=""
                  width="24"
                  height="24"
                  loading="lazy"
                />
              </a>
              <a
                class="lp-footer__socialBtn"
                [href]="footerSocial.x"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
              >
                <img src="/landing/footer/x-24.svg" alt="" width="24" height="24" loading="lazy" />
              </a>
              <a
                class="lp-footer__socialBtn"
                [href]="footerSocial.instagram"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img
                  src="/landing/footer/instagram-24.svg"
                  alt=""
                  width="24"
                  height="24"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </main>
  </div>
}
